export const DefaultPortal = 'DEFAULT_PORTAL';
